package com.appsyde.shared.modules.account.domain.model

sealed class RequestDeletionResult {
    data object Ok : RequestDeletionResult()
    data object AlreadyPending : RequestDeletionResult()
    data class Error(val message: String?) : RequestDeletionResult()
}
